import React, { useState, useEffect, useMemo, useCallback } from 'react'
import B2BLayout from '../../../../layouts/b2b'
import { Button, Table } from 'antd'
import { getColumns } from './columns'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { useNavigate } from 'react-router-dom'
import { MapTitle } from '../../../appeals/card/styles'
import { PlusOutlined } from '@ant-design/icons'
import { TablePaginationConfig } from 'antd/es/table'
import { Sorter } from '../../../../interfaces'
import { objectToUrl } from '../../../utils'
import { DataType } from './interface'

const HRPaymentsList = () => {
  const navigate = useNavigate()
  const [data, setData] = useState<DataType[]>([])
  const [loading, setLoading] = useState(false)
  const [sorter, setSorter] = useState<Sorter>({})
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    total: 10,
    position: ['bottomCenter'],
    showSizeChanger: false,
  })

  /**
   * Хлебные крошки
   */
  const breadcrumbs = useMemo(
    () => [
      {
        href: '/admin',
        title: 'Админка',
      },
      {
        href: '/hr/dashboard',
        title: 'Дашборд',
      },
      {
        title: 'Оплаты',
      },
    ],
    [],
  )

  useEffect(() => {
    try {
      /* Пытаюсь получить список */
      getData()
    } catch (e) {
      alert('Не удалось получить данные, пожалуйста, перезагрузите страницу')
    }
  }, [])

  /**
   * Обновляет состояние пагинации
   */
  const updatePagination = useCallback(
    newState => {
      setPagination({
        ...pagination,
        ...newState,
      })
    },
    [pagination, setPagination],
  )

  /**
   * Получает записи
   */
  const getData = useCallback(() => {
    try {
      setLoading(true)
      const currentUrlParams = Object.fromEntries(new URLSearchParams(location.search))
      fetchAPI(`/api/hr/payments${objectToUrl(currentUrlParams)}`).then(
        ({ data, pagination, sorter }) => {
          if (data) {
            setData(
              data.map(item => ({
                ...item,
              })),
            )
          }
          if (pagination) {
            updatePagination(pagination)
          }
          if (sorter) {
            setSorter(sorter)
          }
          setLoading(false)
        },
      )
    } catch (error) {
      console.error('Ошибка при получении данных:', error)
    }
  }, [])

  /**
   * Отслеживает изменение состояния таблицы
   *
   * @param pagination
   * @param _filters
   * @param sorter
   */
  const handleTableChange = (pagination, _filters, sorter) => {
    const currentUrlParams = Object.fromEntries(new URLSearchParams(location.search))
    const current = {
      ...currentUrlParams,
      sort_order: sorter?.order,
      sort_field: sorter?.field,
      page: pagination.current,
    }
    if (current?.page === 1) {
      delete current.page
    }
    if (current?.sort_order === undefined) {
      delete current.sort_order
      delete current.sort_field
    }
    const urlParams = new URLSearchParams(current).toString()
    navigate({ search: urlParams })
    getData()
  }

  const handleCreate = () => {
    navigate(`/hr/payments/new`)
  }

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <MapTitle>Оплаты</MapTitle>
        <Button onClick={handleCreate}>
          <PlusOutlined /> Добавить оплату
        </Button>
      </div>
      <Table
        showSorterTooltip={{ overlay: 'Нажмите для сортировки', placement: 'bottom' }}
        columns={getColumns(sorter, navigate)}
        rowKey={r => r?.id}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={{
          x: 'max-content',
          y: '72vh',
        }}
        size="small"
      />
    </B2BLayout>
  )
}

export default HRPaymentsList
